<template>
  <v-card height="350" class="pa-8 d-flex flex-column align-center">
    <div class="d-flex flex-column align-center">
      <v-icon size="80" color="yellow darken-1">mdi-alert</v-icon>
      <h1 class="py-2">{{ $t("alert.warning") }}</h1>
    </div>
    <div class="flex-grow-1">
      <h1 class="py-2 body-1"><slot /></h1>
    </div>
    <div v-if="confirmation">
      <CommonButton
        @handleClick="$emit('cancel')"
        color="transparent"
        :label="$t('common.cancel')"
        width="100"
        customClassName="secondary--text font-weight-medium"
      />
      <CommonButton
        color="primary"
        :label="$t('common.yes')"
        width="100"
        customClassName="ml-2"
        @handleClick="$emit('confirm')"
      />
    </div>
    <div v-if="!confirmation">
      <CommonButton
        @handleClick="$emit('cancel')"
        color="default"
        label="Close"
        width="100"
        customClassName="secondary--text font-weight-medium"
      />
    </div>
  </v-card>
</template>

<script>
import CommonButton from "@/views/academy/common/CommonButton";

export default {
  name: "EllipsisConfirmationModal",
  components: { CommonButton },
  props: {
    confirmation: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped></style>
